module.exports = "<li class=\"rw-list-item\"\r\n    ng-class=\"{\r\n      'rw-list-item--no-hover': $ctrl.noHover === true,\r\n      'rw-list-item--no-padding': $ctrl.noPadding === true,\r\n      'rw-list-item--active': $ctrl.active === true\r\n    }\">\r\n  <ng-transclude></ng-transclude>\r\n</li>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-list/components/rw-list-item.html
// module id = 2010
// module chunks = 0